import { render, staticRenderFns } from "./PropertyImportModal.vue?vue&type=template&id=62215201&scoped=true&lang=pug&"
import script from "./PropertyImportModal.vue?vue&type=script&lang=ts&"
export * from "./PropertyImportModal.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyImportModal.vue?vue&type=style&index=0&id=62215201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62215201",
  null
  
)

export default component.exports